import React from "react";
import { AioIconButton } from "./aioIconButton";

interface AioDropSelectProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  value: string;
  availableValues?: Array<string>;
  setValue?: (value: string) => void;
}

/**
 * Wrapper to preprend Icon button with chosen text.
 *
 * @param props - Destructured parameter object
 * @param props.id - The id for the control
 * @param props.value - Current value
 * @param props.setValue - Function to update the value
 * @param props.availableValues - List of available values to select from
 */
export const AioDropSelect = ({
  id,
  value,
  setValue,
  availableValues,
  ...rest
}: AioDropSelectProps): React.ReactElement => {
  return (
    <>
      <div
        {...rest}
        id={id}
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <span
          id={`${id}-value`}
          style={{ marginRight: "0.25rem" }}
          data-available-items={availableValues?.join(",")}
        >
          {value}
        </span>
        {setValue && (
          <AioIconButton
            id={`${id}-button`}
            menuItems={availableValues?.map((s) => ({
              label: s,
              action: () => setValue(s),
            }))}
          />
        )}
      </div>
    </>
  );
};

AioDropSelect.displayName = "AioDropSelect";
